import { useMemo } from 'react';
import { useAgeGroups } from '../../../hooks/admin/persona/useAgeGroups';

/**
 * Hook for age group selection.
 * Fetches active age groups from the admin module.
 *
 * @returns {Object} ageGroups list, loading state, error
 */
export function useAgeGroupSelector() {
  const {
    data: ageGroups = [],
    isLoading: loading,
    error,
  } = useAgeGroups({ isActive: true, pageSize: 500 }, { enabled: true });

  // Sort age groups by name for better UX
  const sortedAgeGroups = useMemo(() => {
    return [...ageGroups].sort((a, b) => {
      const nameA = (a.name ?? '').toLowerCase();
      const nameB = (b.name ?? '').toLowerCase();
      return nameA.localeCompare(nameB);
    });
  }, [ageGroups]);

  return {
    ageGroups: sortedAgeGroups,
    loading,
    error: error?.message ?? error ?? null,
  };
}
